import "../Teaching/Teaching.scss";

export const TeachItem = ({ item }) => (
	<div className="teaching-component">
		<div className="teaching__logo">
			<img
				src={item.logo}
				className="teaching__logo-style"
				alt="university_logo"
			></img>
		</div>
		<div className="teaching__content-wrap">
			<div className="teaching__content">
				<div className="teaching__title">
					<h1 className="teaching__title-style">{item.name}</h1>
					<p className="teaching__text">{item.duration}</p>
				</div>
				<div className="teaching__programs">
					<div className="teaching__program">
						<h2>GRADUATE:</h2>
						<p className="teaching__text">
							{item.graduate.split("\n").map((line, index) => (
								<span key={index}>
									{line}
									<br />
								</span>
							))}
						</p>
					</div>
					{item.underGraduate && (
						<div className="teaching__program">
							<h2>UNDERGRADUATE:</h2>
							<p className="teaching__text">
								{" "}
								{item.underGraduate}
							</p>
						</div>
					)}
				</div>
				{item.curriculum && (
					<div className="teaching__program">
						<h2>CURRICULUM DEVELOPMENT and COORDINATION</h2>
						<p className="teaching__text">{item.curriculum}</p>
					</div>
				)}
			</div>
		</div>
	</div>
);
